import React, { useState, useEffect } from "react";


const DoeBanner = props => {
  
    const [showA2l, setShowA2l] = useState(false);
    const [isLegacyModel, setIsLegacyModel] = useState(props?.isLegacy ?? false);
    var color = "heatcraft_green";
  
    useEffect(() => {
      if (isLegacyModel && !(props?.toggleOn ?? false)) {
        setShowA2l(false);
      } else {
        setShowA2l(true);
      }
    }, [isLegacyModel, props?.toggleOn ?? false]);

    useEffect(() => {
      setIsLegacyModel(props?.isLegacy ?? false);
    }, [props?.isLegacy ?? false]);

  if (props.modelno == "Call Factory")
    return (
      <div className={"banner-main " + color}>
        <div className="ban-row2">
          <div className="row2div">
            <h2 style={{ paddingLeft: 10 }}>
              Please Call Factory at{" "}
              <a href="tel:+18003211881">
                <span> (800)-321-1881</span>
              </a>{" "}
            </h2>
          </div>
        </div>
      </div>
    );
  const ui_refrigerant = props.refrigerant.map(r => {
    return(
      <option  key={r + props.modelno} value={r}>
        {r}
      </option>
    ); 
  });
  let app = "Cooler";
  if (
    (props.type === "HCU" ||
      props.type === "VCU" ||
      props.type === "DVCU" ||
      props.type === "VCU_DVCU" ||
      props.type === "HTS") &&
    props.modelno[7] === "L"
  )
    app = "Freezer";

  if (
    (props.type == "LOP" ||
      props.type == "CM" ||
      props.type == "LVCM" ||
      props.type == "LUC" ||
      props.type == "MP") &&
    (props.modelno[10] === "E" || props.modelno[10] === "H")
  )
    app = "Freezer";
  var message_not_comp = "";

  let message = <React.Fragment />;
  if (props.nochangelegacy) 
  {
    message = "This model is not changing and is not DOE compliant";
    color = "heatcraft_red";
  }
  else if (props.awef === "X") {
    message =
      props.modelno +
      " is not suitable for " +
      props.selected_refrigerant +
      " refrigerant.";
    color = "heatcraft_red";
  } else if (formatDisplayValue(props.awef) === "—" || formatDisplayValue(props.awef) === "-" || formatDisplayValue(props.awef) === "") {

    message =
      // props.modelno +
      "This product does not meet DOE minimum AWEF for " +
      props.selected_refrigerant +
      " refrigerant.";
    color = "heatcraft_red";
  } else if (props.awef === "EXEMPT") {
    message = props.modelno + " is exempted from DOE compliance.";
  } 
  
  else {
    if (!isNaN(props.awef))
      message =
        // "The product is designed and support refrigerants " +
        // app +
        // " application for refrigerants " +
        // props.selectable_ref.join("/") +
        // ". ";
        "This product meets DOE minimum AWEF for "+props.selected_refrigerant+" refrigerant.";
  }

  let hfc_refrigerants = props.refrigerant?.filter(item => 
    item !== "R-454A" && item !== "R-454C" && item !== "R-455A"
  ).map(item => (
    <option key={props.modelno + item} value={item}>
      {item}
    </option>
  ));
      
  let a2l_refrigerants = props.refrigerant?.filter(item => 
    item === "R-454A" || item === "R-454C" || item === "R-455A"
  ).map(item => (
    <option key={props.modelno + item} value={item}>
      {item}
    </option>
  ));

  function formatDisplayValue(value) {

  if(value == "") return '-';
  if (!value || typeof value !== 'string') return value;
  
  // Handle Unicode escape sequences dynamically
  let formattedValue = value;
  
  // Replace Unicode escape sequences with their actual characters
  formattedValue = formattedValue.replace(/\\u([0-9a-fA-F]{4})/g, (match, unicode) => {
    return String.fromCharCode(parseInt(unicode, 16));
  });
  
  // Handle specific Unicode patterns without backslash (like u2015, u00b0)
  const unicodeMap = {
    'u2015': '-',
    'u00b0': '°',
    'u2013': '–',
    'u2014': '-',
    'u00a0': ' ',
    'u2026': '…',
    'u00ae': '®',
    'u2122': '™',
    'u00a9': '©',
    'u00b1': '±',
    'u00d7': '×',
    'u00f7': '÷',
    'u2264': '≤',
    'u2265': '≥'
  };
  
  // Replace known Unicode patterns
  Object.keys(unicodeMap).forEach(unicodeKey => {
    const regex = new RegExp(unicodeKey, 'gi');
    formattedValue = formattedValue.replace(regex, unicodeMap[unicodeKey]);
  });
  
  return formattedValue;
};

  return (
    <div className={"banner-main " + color}>
      <div className="ban-row1">
        <div className="row1div">
          {(!isLegacyModel) && <label>Refrigerant</label>}
          {((isLegacyModel && !showA2l)) && <label>HFC Refrigerant</label>}
          {isLegacyModel && showA2l && <label>A2L Refrigerant</label>}
          <select
            value={props.selected_refrigerant}
            onChange={props.onRefChange}
          >
            {!isLegacyModel && ui_refrigerant}
            {isLegacyModel && !showA2l && hfc_refrigerants}
            {isLegacyModel && showA2l && a2l_refrigerants}
          </select>
        </div>
      </div>
      <div className="ban-row2">
        <div className="row2div">
          <h2>Department of Energy (DOE) AWEF</h2>

          <span className="dynamic_message">{message}</span>
        </div>
      </div>
      <div className="ban-row3">
        <div className="bg-circle">
          <p>AWEF</p>
          <p>{formatDisplayValue(props.awef)}</p>
        </div>
      </div>
    </div>
  );
};
export default DoeBanner;
